import { getEnvSessionData } from 'components/change-env/change-env.utils';

export const isProduction = () =>
  !!window.Cypress ? false : process.env.REACT_APP_ENV === 'production';

export const getEnv = varName => {
  const envVars = isProduction() ? null : getEnvSessionData();

  if (!!envVars?.[varName]) return envVars[varName];

  if (!!window.Cypress) {
    // @ts-ignore
    return window.Cypress.env(varName);
  }

  /* istanbul ignore next */
  if (process.env.STORYBOOK === 'true') {
    const environment = JSON.parse(process.env.STORYBOOK_ENV);
    return environment[varName];
  }

  return process.env[varName];
};
